import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';

export function useTradeSchool(orgId) {
  const [tradeSchoolLogs, setTradeSchoolLogs] = useState([]);
  const [kanganLogs, setKanganLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadAll = useCallback(async () => {
    if (!orgId) return;
    const [ts, kl] = await Promise.all([
      supabase.from('trade_school_log').select('*').eq('org_id', orgId).order('log_date', { ascending: false }),
      supabase.from('kangan_workplace_log').select('*').eq('org_id', orgId).order('visit_date', { ascending: false }),
    ]);
    setTradeSchoolLogs(ts.data || []);
    setKanganLogs(kl.data || []);
    setLoading(false);
  }, [orgId]);

  useEffect(() => {
    if (!orgId) return;
    loadAll();
  }, [orgId, loadAll]);

  async function addTradeSchoolLog(entry) {
    const { error } = await supabase.from('trade_school_log').insert({ ...entry, org_id: orgId });
    if (error) throw error;
    await loadAll();
  }

  async function deleteTradeSchoolLog(id) {
    await supabase.from('trade_school_log').delete().eq('id', id);
    await loadAll();
  }

  async function addKanganLog(entry) {
    const { error } = await supabase.from('kangan_workplace_log').insert({ ...entry, org_id: orgId });
    if (error) throw error;
    await loadAll();
  }

  async function deleteKanganLog(id) {
    await supabase.from('kangan_workplace_log').delete().eq('id', id);
    await loadAll();
  }

  return {
    tradeSchoolLogs,
    kanganLogs,
    loading,
    addTradeSchoolLog,
    deleteTradeSchoolLog,
    addKanganLog,
    deleteKanganLog,
    reload: loadAll,
  };
}
